export const getters = {
  getAccounts: state => state.accounts
}
